export default __webpack_public_path__ + "static/media/icon-prize.8ae58ef9.png";